import { render } from "./ProsesSlider.vue?vue&type=template&id=e1b0d4b4"
import script from "./ProsesSlider.vue?vue&type=script&lang=js"
export * from "./ProsesSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__